import {InjectionToken} from '@angular/core';

export const DEPLOY_URL = new InjectionToken<string>('deployUrl');
